export default __webpack_public_path__ + "static/media/current_tag.643100d4.svg";